import { IPatient } from "../interfaces/IPatient";
import { IPatientPayload } from "../interfaces/IPatientPayload";
import { ApiService } from "./apiService";

export const getPatients = async (activeOnly: boolean = false): Promise<IPatient[]> => {
    return (await ApiService.retryGet(`${process.env.REACT_APP_API_URL}/api/patients/${activeOnly}`)).data;
};

export const getPatient = async (patientId: string, includeUserProfileImages: boolean = false): Promise<IPatient> => {
    return (await ApiService.retryGet(`${process.env.REACT_APP_API_URL}/api/patients/${patientId}/${includeUserProfileImages}`)).data;
};

export const addPatient = async (patient: IPatientPayload): Promise<IPatient> => {
    return (await ApiService.retryPost(`${process.env.REACT_APP_API_URL}/api/patients`, patient)).data;
};

export const editPatient = async (patientId: string, patient: IPatientPayload): Promise<IPatient> => {
    return (await ApiService.retryPut(`${process.env.REACT_APP_API_URL}/api/patients/${patientId}`, patient)).data;
};

export const deletePatient = async (patientId: string) => {
    return (await ApiService.retryDelete(`${process.env.REACT_APP_API_URL}/api/patients/${patientId}`)).data;
};
